/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.wifi.ts
 *
 * Messages de la carte « Wi-Fi du salon » (accueil), du rappel du réseau de
 * l'équipe (écran de contrôle) et de leurs réglages (back-office, écran
 * « Étape du salon »). 2026-10-07, demande de Mika. Fusionné dans fr.ts.
 * Le type d'événement passe par {eventTypeOf} ; aucun nom de réseau ici.
 *
 * Mikael - chef de projet - 2026-10-07
 */
export const messagesWifiFr: Record<string, string> = {
  // ── Carte de l'accueil ──────────────────────────────────────────────────
  'wifi.carte.titre': 'Wi-Fi {eventTypeOf}',
  'wifi.carte.connectez': 'Connectez-vous au Wi-Fi {eventTypeOf} : {nom}',
  'wifi.carte.motDePasse': 'Mot de passe : {mdp}',
  'wifi.carte.ouvert': 'Réseau ouvert, sans mot de passe.',
  'wifi.carte.reglages': 'Sur ce téléphone : Réglages > Wi-Fi, puis choisissez « {nom} ».',
  'wifi.carte.qr': 'Pour un autre téléphone : ouvrez son appareil photo et visez ce code.',
  'wifi.carte.qrAlt': 'Code QR de connexion au réseau {nom}',
  'wifi.carte.copier': 'Copier le mot de passe',
  'wifi.carte.copie': 'Mot de passe copié.',
  'wifi.carte.copieEchec': 'Copie impossible : recopiez le mot de passe à la main.',
  // ── Page /wifi, ouverte depuis « Plus » (2026-10-07) ─────────────────────
  'wifi.page.titre': 'Wi-Fi',
  'wifi.page.chargement': 'Chargement des informations Wi-Fi…',
  'wifi.page.indisponible': 'Les informations Wi-Fi seront disponibles le jour {eventTypeOf}.',
  'wifi.plus.lien': 'Wi-Fi',
  // ── Réseau de l'équipe ──────────────────────────────────────────────────
  'wifi.equipe.titre': 'Réseau de l’équipe',
  'wifi.equipe.intro': 'Réservé à l’équipe et à ceux qui scannent : ne le communiquez pas aux visiteurs.',
  'wifi.equipe.nom': 'Réseau : {nom}',
  'wifi.equipe.afficher': 'Afficher le mot de passe',
  'wifi.equipe.masquer': 'Masquer le mot de passe',
  'wifi.equipe.rappel': 'Wi-Fi de l’équipe : {nom}',
  // ── Back-office ─────────────────────────────────────────────────────────
  'wifi.admin.titre': 'Wi-Fi {eventTypeOf}',
  'wifi.admin.intro':
    'Activée, une carte s’affiche en tête de l’accueil de l’application avec le nom du réseau des visiteurs, son mot de passe et un code QR. Le réseau de l’équipe n’est montré qu’aux profils cochés, après connexion.',
  'wifi.admin.actif': 'Afficher la carte Wi-Fi sur l’accueil',
  'wifi.admin.nom': 'Nom du réseau des visiteurs (SSID)',
  'wifi.admin.mdp': 'Mot de passe du réseau des visiteurs (vide : réseau ouvert)',
  'wifi.admin.aPartir': 'Afficher à partir du',
  'wifi.admin.aPartirDefaut': 'Vide : le jour de l’événement à 7 h ({defaut}).',
  'wifi.admin.equipeNom': 'Nom du réseau de l’équipe (SSID)',
  'wifi.admin.equipeMdp': 'Mot de passe du réseau de l’équipe',
  'wifi.admin.afficher': 'Afficher',
  'wifi.admin.masquer': 'Masquer',
  'wifi.admin.roles': 'Profils qui voient le réseau de l’équipe',
  'wifi.admin.role.staff': 'Organisation et équipe de scan',
  'wifi.admin.role.exhibitor': 'Exposants et animateurs',
  'wifi.admin.role.visitor': 'Visiteurs',
  'wifi.admin.role.accompagnateur': 'Accompagnateurs',
  'wifi.admin.role.vip': 'Invités',
  'wifi.admin.enregistrer': 'Enregistrer',
  'wifi.admin.enregistre': 'Réglages Wi-Fi enregistrés.',
  'wifi.admin.erreur': 'Enregistrement impossible : vérifiez les champs.',
  'wifi.admin.lectureSeule': 'Seuls les administrateurs peuvent modifier ces réglages.',
};
